import type { IconSvgObject } from './types';

const ZodiacOphiuchusIcon: IconSvgObject = [
  ["path", { d: "M6 3V15C6 18.3137 8.68629 21 12 21C15.3137 21 18 18.3137 18 15V3", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 9.99893C6 6.93786 9 7.7607 12 10.0004C15 12.2401 18 13.0615 21 10.0004", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ZodiacOphiuchusIcon;
